<template>
  <div class="contents_wrapper">
    <Header :title="'エラー'"/>
    <div class="contents">
      <div class="error_main">
        <div class="error_message">
          <p>エラーが発生しました</p>
          <p>管理者にお問い合わせください</p>
          <p class="selectable">[ErrorCode] {{errorCode}}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Header from "../components/Header.vue";
import loggerService from "../services/loggerService";

export default {
  components: {
    Header
  },
  data: function() {
    return {
      errorCode: null
    };
  },
  created: function() {
    this.errorCode = this.$route.query["errorCode"];
    loggerService.pageView("Error", {errorCode: this.errorCode});
  }
};
</script>

<style lang="scss">
@charset "utf-8";
.error_main {
  padding: 30px 50px 0;
}
.error_message {
  width: 100%;
  text-align: center;
}
.error_message > p {
  padding: 8px;
}
</style>